
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class SecurityMatchRulesetDialog extends SiteEntityDialog<SecurityMatchRulesetRow, any> {
        protected getFormKey() { return SecurityMatchRulesetForm.formKey; }
        protected getIdProperty() { return SecurityMatchRulesetRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityMatchRulesetRow.localTextPrefix; }
        protected getNameProperty() { return SecurityMatchRulesetRow.nameProperty; }
        protected getService() { return SecurityMatchRulesetService.baseUrl; }
        protected getDeletePermission() { return SecurityMatchRulesetRow.deletePermission; }
        protected getInsertPermission() { return SecurityMatchRulesetRow.insertPermission; }
        protected getUpdatePermission() { return SecurityMatchRulesetRow.updatePermission; }
        protected form = new SecurityMatchRulesetForm(this.idPrefix);

        constructor(container: JQuery) {
            super(container);
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();
            var that = this;
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "clone-button"), 1);
            buttons.push({
                title: 'Clone',
                cssClass: 'clone-button',
                icon: 'fa-copy',
                onClick: () => {
                    var cloneEntity = this.getCloningEntity();
                    cloneEntity.SecurityMatchRuleList.forEach(that.removeVersion);
                    Serenity.Widget.create({
                        type: Q.getInstanceType(this),
                        init: w => Serenity.SubDialogHelper.bubbleDataChange(Serenity.SubDialogHelper.cascade(w, this.element), this, true).loadEntityAndOpenDialog(cloneEntity, false)
                    });
                }
            });
            return buttons;
        }

        protected removeVersion(item) {
            item.Version = null;
            item.CreatedBy = null;
            item.CreatedWhen = null;
            item.UpdatedBy = null;
            item.UpdatedWhen = null;
        }
    }
}
